import { motion } from "framer-motion";
import { FileText } from "lucide-react";

import type { BriefFile } from "../types";

export function Thumbnail({ file }: { file: BriefFile }) {
  return (
    <motion.div
      className="flex w-[136px] shrink-0 flex-col gap-1.5"
      transition={{ damping: 20, stiffness: 300, type: "spring" }}
      whileHover={{ y: -2 }}
    >
      <div className="group relative aspect-square overflow-hidden rounded-lg border border-border-secondary bg-bg-secondary">
        {file.src ? (
          <img
            alt={file.caption}
            className="size-full object-cover transition-transform duration-300 group-hover:scale-105"
            src={file.src}
          />
        ) : (
          <div className="flex size-full flex-col items-center justify-center gap-2">
            <div
              className="flex size-11 items-center justify-center rounded-md text-white"
              style={{ backgroundColor: file.extColor }}
            >
              <FileText className="size-5" />
            </div>
            <span className="text-xs font-semibold text-text-secondary">
              {file.ext}
            </span>
          </div>
        )}
      </div>
      <span className="truncate text-xs text-text-tertiary">
        {file.caption}
      </span>
    </motion.div>
  );
}
